import React from 'react';
import tecno from '../../Tecno-list/tecno';
import { Link } from 'react-router-dom';

function Kanjaban() {
    
    return (
        <React.Fragment>
            <section className='Proyect'>

                <h2 className="">Kanjaban</h2>
                <div className='folder-porfolio'>

                    <iframe src="https://www.youtube.com/embed/0VUgrZptHR4" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>

                    <div className="list" >
                        {tecno.filter(tec => tec.T === 'MySql' || tec.T === 'Java').map(tec => (

                            <div key={tec.T}>

                                <a href={tec.L} target="_blank" rel="noreferrer">

                                    <button className="etiqueta">  <p> <span>&#183;</span> {tec.T}</p></button>
                                </a>
                            </div>

                        ))}
                    </div>

                    <p className='white'>
                        Kanjaban is an application made in java using NetBeans and MySql 
                        to organize personal projects based on the kanban methodology focused on a single user.
                    </p>

                    <a href="https://github.com/BrandonGrimaldoM/Kanjaban" target="_blank" rel="noreferrer">
                        <button className="Git"> <p>Repository </p> <div className="gitIcon"></div> </button>
                    </a>
                </div>
                <div className='after'>
                    <Link to="/desktop" className="Link">  <div className='iconAfter'>  <p className='flecha'>←</p></div>  </Link>
                </div>
            </section>
        </React.Fragment>
    );
}
export default Kanjaban;